/* eslint-disable react/jsx-no-target-blank */
import { Paper } from '@material-ui/core';
import moment from 'moment';
import React from 'react';
import { useSelector } from 'react-redux';

const UOARightPanel = ({ styles }) => {
  const { appReducer } = useSelector((state) => state);
  const { generalArticles } = appReducer;
  return (
    <div style={{ height: '100%' }}>
      <div style={{ ...styles.rightContainer }}>
        <Paper style={styles.stockPaper} className="sticky">
          {/* <AdCarousel /> */}
          <a
            href="https://optionsgeek.com/unusual-options-activity-guide/"
            target="_blank"
          >
            <img src="uoapic.png" alt="" height="100%" width="100%" />
          </a>
        </Paper>
        <h3 style={styles.articlesTitleFixed}>Market Articles</h3>
        <div style={styles.articlesFixed}>
          {generalArticles.map((article, id) => {
            return (
              <div key={id} style={styles.newsContainer}>
                <div>
                  <img
                    style={styles.leftNewsPic}
                    src={article.image_url}
                    alt=""
                  />
                </div>
                <div style={styles.rightNews}>
                  <a
                    href={article.news_url}
                    //  target="_blank"
                  >
                    {article.title.length > 50
                      ? article.title.substring(0, 49) + '...'
                      : article.title}
                  </a>
                </div>
                <div style={{ fontSize: '0.8rem' }}>
                  {moment(article.date).format('MM/DD/YYYY')}
                  {' | By: ' + article.source_name + ' | '}
                  <span
                    style={
                      article.sentiment === 'Neutral'
                        ? { color: 'gray' }
                        : article.sentiment === 'Negative'
                        ? { color: 'red' }
                        : { color: 'green' }
                    }
                  >
                    {article.sentiment}
                  </span>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};
export default UOARightPanel;



// WEBPACK FOOTER //
// ./src/Pages/UnusualOptionsActivity/components/UOARightPanel.jsx